export const data7_6_default = [{
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}, {
    training_topics: '',
    department: "",
    facilitator: "",
    title: "",
    duration_hours: "",
    participants_num: 0,
    participants_num: 0,
    remarks: "",
}];


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-6/data.js